// extracted by mini-css-extract-plugin
export default {"confirmation":"ReturnInProgressConfirmation_confirmation__fENQW","buttonGrid":"ReturnInProgressConfirmation_buttonGrid__HUPs+"};